import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessEntities } from "../AccessEntities";
import { AccessLayout } from "../AccessLayout";
import { AccessProps } from "../AccessProps";

interface PolicyViewProps extends NSARouterMakerResult, AccessProps { }

function PolicyViewPage(props: PolicyViewProps)
{

    return (
        <AccessLayout
            {...props}
            pages={{
                entity: AccessEntities.policy(props),
                view: {}
            }}
        >
            <></>
        </AccessLayout>
    );
}

export default PolicyViewPage;